module.exports = __webpack_public_path__ + "img/out.6b3a5f87.png";